<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <detail-row-component title="국가 이름" :inner-vertical="true">

          <layout-input v-model="editable.country"
                        :regex="regex(2, 100).ko_num"
                        placeHolder="한글 이름을 입력해주세요." />

          <layout-input v-model="editable.countryEn"
                        :regex="regex(2, 100).en_num"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 1 이름" :inner-vertical="true">

          <layout-input v-model="editable.region1"
                        :regex="regex(2, 100).ko_num"
                        placeHolder="한글 이름을 입력해주세요."/>

          <layout-input v-model="editable.region1En"
                        :regex="regex(2, 100).en_num"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 2 이름" :inner-vertical="true">

          <layout-input v-model="editable.region2"
                        placeHolder="한글 이름을 입력해주세요."/>

          <layout-input v-model="editable.region2En"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 3 이름" :inner-vertical="true">

          <layout-input v-model="editable.region3"
                        placeHolder="한글 이름을 입력해주세요."/>

          <layout-input v-model="editable.region3En"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 4 이름" :inner-vertical="true">

          <layout-input v-model="editable.region4"
                        placeHolder="한글 이름을 입력해주세요."/>

          <layout-input v-model="editable.region4En"
                        placeHolder="영문 이름을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 설명">

          <layout-textarea v-model="editable.regionDsc"
                           placeHolder="지역 설명을 입력해주세요."/>

        </detail-row-component>

        <detail-row-component title="지역 이미지">

          <layout-image-selector v-model="editable.imgRegion"
                                 :index="`image_region${rowData.id}`"
                                 :on-image-out-of-size="onImageOutOfSize"/>

        </detail-row-component>

        <detail-row-component title="발행">

            <layout-switch-button v-model="editable.isChecked"/>

        </detail-row-component>

      </div>
    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';

import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';

import LayoutInput from '@/spa/components/LayoutInput';
import LayoutSwitchButton from '@/spa/components/LayoutSwitchButton';
import LayoutImageSelector from '@/spa/components/LayoutImageSelector';
import LayoutTextarea from '@/spa/components/LayoutTextarea';

export default {
  name: 'RegionEditor',
  components: {
    DetailRowWrapper,
    DetailRowComponent,

    LayoutInput,
    LayoutSwitchButton,
    LayoutImageSelector,
    LayoutTextarea,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    onImageOutOfSize() {
      this.$toast('사이즈가 4메가가 넘습니다.');
    },

    regex(min, max) {
      return regex(min, max);
    },

    async uploadImage(image) {
      if (!image) return null;
      if (typeof image === 'string') return image;

      const result = await this.$store.dispatch('imageUploadS3', { name: 'region', image });

      if (!result.response) return image;
      this.$toast(result.message);
      this.$toast('데이터베이스 업로드 작업중 입니다. 조금만 기다려주세요.');

      return result.response.location;
    },

    async submit() {
      this.editable.id = this.rowData.id;
      this.editable.imgRegion = await this.uploadImage(this.editable.imgRegion);

      const validateResult = multipleValidate([
        validate({ message: '국가 이름', target: this.editable.country, regex: this.regex(1, 100).ko_num }),
        validate({ message: '국가 영문 이름', target: this.editable.countryEn, regex: this.regex(1, 100).en_num }),
        validate({ message: '지역 이름 1', target: this.editable.region1, regex: this.regex(1, 100).ko_num }),
        validate({ message: '지역 영문 이름 1', target: this.editable.region1En, regex: this.regex(1, 100).en_num }),
      ]);

      if (this.editable.isChecked && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      const result = await this.$store.dispatch('updateRegion', this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        country: this.rowData.country,
        countryEn: this.rowData.country_en,
        region1: this.rowData.region1,
        region1En: this.rowData.region1_en,
        region2: this.rowData.region2,
        region2En: this.rowData.region2_en,
        region3: this.rowData.region3,
        region3En: this.rowData.region3_en,
        region4: this.rowData.region4,
        region4En: this.rowData.region4_en,
        regionDsc: this.rowData.region_dsc,
        imgRegion: this.rowData.img_region,
        isChecked: this.rowData.is_checked,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: 600px;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/region/detail-row/RegionEditor.vue